export default function To(component) {
  const Component = () => component;

  Component.displayName = `To(${component.type.displayName || component.type.name || 'anonymous'})`;

  return Component;
}
